import { useSelector } from 'react-redux';
import { selectCollarType } from '@store/order/selectors';



const CollarType = (): JSX.Element => {

	const collarType = useSelector(selectCollarType);

	return (
		<div className='order-summary-element'>

			<h2>Typ límce</h2>

			<div className='summary-property'>
				<p>{collarType ? collarType : '-'}</p>
			</div>

		</div>
	);
};

export default CollarType;